module.exports = __webpack_public_path__ + "img/3.ea11ee12.png";